import { Grow } from '@mui/material'
import Popper from '@mui/material/Popper'
import { COLORS } from '@repo/design-system/index'
import { QIcon_close_default } from '@repo/icons/index'
import React from 'react'

interface PopperTooltipProps {
  anchorEl: HTMLElement | null
  open?: boolean
  width?: number | string
  onClose?: () => void
  children: React.ReactNode
  zIndex?: number
}

const PopperTooltip: React.FC<PopperTooltipProps> = ({
  anchorEl,
  open = true,
  width = 220,
  onClose,
  children,
  zIndex = 2,
}) => {
  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement="bottom"
      transition // ← transition 모드를 켭니다
      modifiers={[{ name: 'offset', options: { offset: [0, 8] } }]}
      style={{ zIndex: zIndex, overflow: 'visible' }}
    >
      {({ TransitionProps }) => (
        <Grow {...TransitionProps} timeout={200}>
          <div
            style={{
              position: 'relative',
              display: 'inline-block',
              overflow: 'visible',
            }}
          >
            {/* arrow */}
            <div
              className="bg-purple-800"
              style={{
                position: 'absolute',
                width: 12,
                height: 12,
                transform: 'translateY(-50%) rotate(45deg)',
                top: 0,
                left: '50%',
                marginLeft: -6,
              }}
            />

            {/* content */}
            <div
              className="bg-purple-800 p-[12px] flex flex-row"
              style={{
                width,
                borderRadius: '8px',
                whiteSpace: 'pre-line',
              }}
            >
              <div className="Body2-14Md flex-1" style={{ color: 'white' }}>
                {children}
              </div>
              {onClose && (
                <div style={{ color: 'white', cursor: 'pointer', marginLeft: 8 }} onClick={onClose}>
                  <QIcon_close_default width={16} height={16} color={COLORS.WHITE} />
                </div>
              )}
            </div>
          </div>
        </Grow>
      )}
    </Popper>
  )

  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement="bottom"
      modifiers={[
        {
          name: 'offset',
          options: { offset: [0, 8] },
        },
      ]}
      style={{ zIndex: 2, overflow: 'visible' }}
    >
      <div
        style={{
          position: 'relative',
          display: 'inline-block',
          overflow: 'visible',
        }}
      >
        {/* arrow */}
        <div
          className="bg-purple-800"
          style={{
            position: 'absolute',
            width: 12,
            height: 12,
            transform: 'translateY(-50%) rotate(45deg)',
            top: 0,
            left: '50%',
            marginLeft: -6,
          }}
        />

        {/* content */}
        <div
          className="bg-purple-800 p-[12px] flex flex-row"
          style={{
            width,
            borderRadius: '8px',
            whiteSpace: 'pre-line',
          }}
        >
          <div className="Body2-14Md flex-1" style={{ color: 'white' }}>
            {children}
          </div>
          {onClose && (
            <div style={{ color: 'white', cursor: 'pointer', marginLeft: 8 }} onClick={onClose}>
              <QIcon_close_default width={16} height={16} color={COLORS.WHITE} />
            </div>
          )}
        </div>
      </div>
    </Popper>
  )
}

export default PopperTooltip
